import App from './App.vue';
import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import '@vue-storefront/core/lib/passive-listeners'
import { isServer } from '@vue-storefront/core/helpers/isServer'
import { once } from '@vue-storefront/core/helpers/once'
import { cartModule } from './store/cart'
import { claimsStore } from 'theme/store/claims'
import { StorageManager } from '@vue-storefront/core/lib/storage-manager'

import VueScrollTo from 'vue-scrollto'

import { uiStore } from 'theme/store/ui'
import { ekomiStore } from 'theme/store/ekomi'

once('__VUE_EXTEND_DROPPOINT_VPB__', () => {
  if (!isServer) {
    Vue.use(VueScrollTo)
  }
  Vue.use(VueProgressBar)
})

const themeEntry = App
function initTheme (app, router, store, config, ssrContext) {
  app.$Lazyload.options.src = '/assets/placeholder.svg'
  // app.$Lazyload.options.loading = '/assets/placeholder.svg'
  app.$Lazyload.options.filter.webp = (listener, options) => {
    if (!options.supportWebp || !listener.src || !listener.src.startsWith('/assets')) {
      return
    }
    // Only `placeholder.jpg` / `placeholder.svg` exist — do not rewrite to `.webp` (ENOENT on theme assets).
    if (listener.src.includes('placeholder')) {
      return
    }
    listener.src = listener.src
      .replace('.png', '.webp')
      .replace('.jpg', '.webp')
  }

  // `createApp` runs more than once (e.g. every SSR request) while `store` is a singleton;
  // re-registering would duplicate getters and confuse Vuex.
  if (!store.hasModule('themeCart')) {
    store.registerModule('themeCart', cartModule)
  }
  // Theme routes are registered in core/app.ts (before root Vue is created) so the router’s
  // initial transition does not hit the URL dispatcher with an empty matcher.

  StorageManager.init('claims');
  if (!store.hasModule('claims')) {
    store.registerModule('claims', claimsStore);
  }
  if (!store.hasModule('ui')) {
    store.registerModule('ui', uiStore);
  }
  if (!store.hasModule('ekomi')) {
    store.registerModule('ekomi', ekomiStore);
  }
}

export {
  themeEntry,
  initTheme
}
